/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Asset {
  id?: number;
  active?: boolean;
  code?: string;
  name?: string;
  qtyScale?: number;
  refPriceUsd?: number;
  fiat?: boolean;
  manualRate?: boolean;
}
